module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/30kowWaRh6k6CwaSW6ksyc-3efdcaca88fdb760248852988ea0396c.jpg";